import { useNavigate } from 'react-router-dom';
import './fundraising.css';
import image from '../images/donations-img.png'; 

function Fundraising() {
  const navigate = useNavigate();
  const toHome = () => navigate('/');

  return (
    <div className = "fundraising-total-container">
      <section className="fundraising-intro">
        <div className="fundraising-intro-content">
          <h1>Empowering The Next Generation of African-American Physicians</h1>
          <p>
            At FAAMS, our mission is to provide financial support and educational opportunities
            to African-American students pursuing careers in medicine. We believe healthcare's
            future depends on diversity and representation at every level.
          </p>
          <div className="stats-cards">
            <div className="donation-card">
              <i class="fa-solid fa-hospital"></i>
              <p>The healthcare system often builds race into clinical tools in ways that disadvantage people of color.</p>
            </div>
            <div className="donation-card">
              <i className="fa-solid fa-user-doctor"></i>
              <p>Only 5% of U.S. physicians are African American</p>
            </div>
            <div className="donation-card">
              <i className="fa-solid fa-graduation-cap"></i>
              <p>In 2019, just 7.4% of medical school applicants identified as African American</p>
            </div>
          </div>
          <div className='fundraising-button-row'>
            <button className='fundraising-home-btn' onClick={toHome}>Learn More</button>
          </div>
        </div>
      </section>
        <aside className="donate-form-wrapper">
            <h2>Donate Now</h2>
            <div className="zeffy-container">
              <iframe
                title="Donation form powered by Zeffy"
                src="https://www.zeffy.com/embed/donation-form/donate-to-impact-lives"
                allowPaymentRequest
                allowTransparency="true"
              ></iframe>
            </div>
        </aside>
    </div>
  );
}

export default Fundraising;
